import type { ZudokuConfig } from "zudoku";
import { apis } from "./zudoku/apis";
import { catalogs } from "./zudoku/catalogs";
import { authenticationPlugin } from "./zudoku/authentication";
import { apiIdentitiesPlugin } from "./zudoku/apiIdentities";
import { metadata } from "./zudoku/metadata";
import { navigation } from "./zudoku/navigation";
import { protectedRoutes, redirects } from "./zudoku/routes";
import { search } from "./zudoku/search";
import { site } from "./zudoku/site";
import { theme } from "./zudoku/theme";

const config: ZudokuConfig = {
	metadata,
	site,
	navigation,
	redirects,
	apis,
	search,
	plugins: [authenticationPlugin, apiIdentitiesPlugin],
	theme,
	protectedRoutes,
};

export default config;
